import styles from './Data.module.css'

export function TableSurface({
  children,
  toolbar = null,
  state = null,
  footer = null,
  label = 'Table',
  busy = false,
  className = '',
}) {
  return (
    <div className={`${styles.surface} ${className}`.trim()}>
      {toolbar ? <div className={styles.surfaceToolbar}>{toolbar}</div> : null}
      {state ? (
        <div className={styles.surfaceState}>{state}</div>
      ) : (
        <div
          className={styles.tableRegion}
          role="region"
          aria-label={`${label}, horizontally scrollable when needed`}
          aria-busy={busy || undefined}
          tabIndex={0}
        >
          {children}
        </div>
      )}
      {footer ? <div className={styles.surfaceFooter}>{footer}</div> : null}
    </div>
  )
}
